import { IS_PROD } from '@cast/constants';

export const isDevToolboxEnabled = () => {
  return !IS_PROD;
};
